module.exports = __webpack_public_path__ + "static/media/logo.3f7bddc6.png";